var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.47412 2.77652C9.97132 2.27932 10.6457 2 11.3488 2C12.0519 2 12.7263 2.27932 13.2235 2.77652C13.7207 3.27372 14 3.94806 14 4.6512C14 5.35434 13.7207 6.02869 13.2235 6.52588L5.95219 13.7972C5.82232 13.927 5.64618 14 5.46252 14H2.6925C2.31004 14 2 13.69 2 13.3075V10.5375C2 10.3538 2.07296 10.1777 2.20283 10.0478L8.78149 3.46915L9.47412 2.77652ZM9.27129 4.93804L3.38501 10.8243V12.615H5.17567L11.062 6.72871L9.27129 4.93804ZM12.0413 5.74936L10.2506 3.9587L10.4535 3.75587C10.6909 3.51841 11.013 3.38501 11.3488 3.38501C11.6846 3.38501 12.0067 3.51841 12.2441 3.75587C12.4816 3.99332 12.615 4.31538 12.615 4.6512C12.615 4.98702 12.4816 5.30908 12.2441 5.54653L12.0413 5.74936Z",
    fill: "#181A1A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencil);
export default __webpack_public_path__ + "static/media/icon_pencil.c9c554dcd30d35d0d15eadb03fe869b6.svg";
export { ForwardRef as ReactComponent };